import $http from '@/plugins/axios'

const RESOURCE_NAME = '/admin/imprints'

export default {
  getImprintById (id) {
    return $http().get(`${RESOURCE_NAME}/${id}`)
  },

  getImprintsPaged (skipCount, maxResultCount, keyword, dataSourceId, importFilter) {
    return $http().get(RESOURCE_NAME, {
      params: {
        skipCount,
        maxResultCount,
        keyword,
        dataSourceId,
        importFilter
      }
    })
  },

  updateImprint (imprint) {
    return $http().patch(`${RESOURCE_NAME}/${imprint.id}`, imprint)
  },

  updateImprintTenants (id, tenants) {
    return $http().patch(`${RESOURCE_NAME}/${id}/tenants`, tenants)
  }
}
